import client from "./client";

const getPermissions = () =>
  client.get("/subsidiary/dashboard/role/permissions");

export default { getPermissions };
